// LocalStorage-backed store for the built-in Accounting module
import { invoicePaid, invoiceOutstanding } from './invoiceItems';

const KEY = 'pp_accounting_v1';

const uid = (p) => `${p}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,6)}`;

const seed = () => ({
  customers: [
    { id: 'C-001', name: 'Anderson Residence', email: 'anderson@example.com', phone: '(512) 555-0142', balance: 0, type: 'Residential' },
    { id: 'C-002', name: 'Brewster Office Complex', email: 'ap@brewsterco.com', phone: '(512) 555-0188', balance: 1240, type: 'Commercial' },
    { id: 'C-003', name: 'Carter Family Home', email: 'carter.j@example.com', phone: '(512) 555-0117', balance: 85, type: 'Residential' },
    { id: 'C-004', name: 'Delgado Restaurant', email: 'manager@delgados.com', phone: '(512) 555-0199', balance: 0, type: 'Commercial' },
    { id: 'C-005', name: 'Eastwood Apartments', email: 'pm@eastwoodapts.com', phone: '(512) 555-0150', balance: 3200, type: 'Multi-Unit' },
  ],
  vendors: [
    { id: 'V-001', name: 'BugOff Chemical Supply', email: 'orders@bugoff.com', phone: '(800) 555-2200', balance: 1850 },
    { id: 'V-002', name: 'Shell Fleet Fuel', email: 'fleet@shell.com', phone: '(800) 555-4400', balance: 0 },
    { id: 'V-003', name: 'PestEquip Wholesale', email: 'sales@pestequip.com', phone: '(800) 555-1188', balance: 940 },
    { id: 'V-004', name: 'Office Depot', email: 'biz@officedepot.com', phone: '(800) 555-0001', balance: 230 },
  ],
  products: [
    { id: 'P-001', name: 'Quarterly Pest Treatment', type: 'Service', price: 149, account: 'Service Revenue' },
    { id: 'P-002', name: 'Termite Inspection', type: 'Service', price: 195, account: 'Service Revenue' },
    { id: 'P-003', name: 'Bed Bug Treatment', type: 'Service', price: 595, account: 'Service Revenue' },
    { id: 'P-004', name: 'Rodent Exclusion', type: 'Service', price: 425, account: 'Service Revenue' },
    { id: 'P-005', name: 'Commercial IPM Monthly', type: 'Service', price: 320, account: 'Service Revenue' },
    { id: 'P-006', name: 'Mosquito Treatment', type: 'Service', price: 89, account: 'Service Revenue' },
  ],
  invoices: [
    { id: 'INV-1001', customerId: 'C-002', date: '2025-06-22', due: '2025-07-22', status: 'Overdue', items: [{ productId: 'P-005', desc: 'Commercial IPM Monthly', qty: 1, rate: 320 }, { productId: 'P-002', desc: 'Termite Inspection', qty: 1, rate: 195 }], total: 515, paid: 0 },
    { id: 'INV-1002', customerId: 'C-005', date: '2025-06-28', due: '2025-07-28', status: 'Open', items: [{ productId: 'P-001', desc: 'Quarterly Pest Treatment', qty: 12, rate: 149 }], total: 1788, paid: 0 },
    { id: 'INV-1003', customerId: 'C-003', date: '2025-07-01', due: '2025-07-31', status: 'Open', items: [{ productId: 'P-001', desc: 'Quarterly Pest Treatment', qty: 1, rate: 149 }], total: 149, paid: 0 },
    { id: 'INV-1004', customerId: 'C-001', date: '2025-06-15', due: '2025-07-15', status: 'Paid', items: [{ productId: 'P-001', desc: 'Quarterly Pest Treatment', qty: 1, rate: 149 }], total: 149, paid: 149 },
    { id: 'INV-1005', customerId: 'C-004', date: '2025-07-02', due: '2025-08-01', status: 'Paid', items: [{ productId: 'P-004', desc: 'Rodent Exclusion', qty: 1, rate: 425 }], total: 425, paid: 425 },
  ],
  estimates: [
    { id: 'EST-2001', customerId: 'C-003', date: '2025-07-05', expires: '2025-08-05', status: 'Pending', items: [{ desc: 'Termite Treatment Plan', qty: 1, rate: 1800 }], total: 1800 },
    { id: 'EST-2002', customerId: 'C-005', date: '2025-07-08', expires: '2025-08-08', status: 'Accepted', items: [{ desc: 'Annual Multi-Unit Contract', qty: 1, rate: 14400 }], total: 14400 },
  ],
  expenses: [
    { id: 'EXP-3001', date: '2025-07-01', vendorId: 'V-001', category: 'Chemicals & Supplies', amount: 1850, method: 'Card', memo: 'Q3 chemical restock' },
    { id: 'EXP-3002', date: '2025-07-02', vendorId: 'V-002', category: 'Fuel', amount: 612, method: 'Card', memo: 'Fleet fueling' },
    { id: 'EXP-3003', date: '2025-07-03', vendorId: 'V-004', category: 'Office Supplies', amount: 230, method: 'Card', memo: 'Printer ink + paper' },
    { id: 'EXP-3004', date: '2025-07-05', vendorId: 'V-003', category: 'Equipment', amount: 940, method: 'Check', memo: 'New sprayer units' },
  ],
  bills: [
    { id: 'BILL-4001', vendorId: 'V-001', date: '2025-07-04', due: '2025-08-03', amount: 1850, status: 'Open', memo: 'Net 30 – Chemical order #88421' },
    { id: 'BILL-4002', vendorId: 'V-003', date: '2025-07-06', due: '2025-08-05', amount: 940, status: 'Open', memo: 'Sprayer order' },
  ],
  transactions: [
    { id: 'T-1', date: '2025-07-08', account: 'Operating Checking', desc: 'Stripe Payout', amount: 4825.50, type: 'Deposit', matched: true },
    { id: 'T-2', date: '2025-07-07', account: 'Operating Checking', desc: 'BugOff Chemical', amount: -1850, type: 'Withdrawal', matched: true },
    { id: 'T-3', date: '2025-07-06', account: 'Operating Checking', desc: 'Shell Fuel', amount: -612, type: 'Withdrawal', matched: true },
    { id: 'T-4', date: '2025-07-05', account: 'Business Card', desc: 'Office Depot', amount: -230, type: 'Withdrawal', matched: true },
    { id: 'T-5', date: '2025-07-04', account: 'Operating Checking', desc: 'Customer Payment – Delgado', amount: 425, type: 'Deposit', matched: true },
    { id: 'T-6', date: '2025-07-03', account: 'Operating Checking', desc: 'Customer Payment – Anderson', amount: 149, type: 'Deposit', matched: true },
    { id: 'T-7', date: '2025-07-09', account: 'Operating Checking', desc: 'Unmatched Deposit', amount: 312.40, type: 'Deposit', matched: false },
    { id: 'T-8', date: '2025-07-09', account: 'Business Card', desc: 'Amazon Business', amount: -89.99, type: 'Withdrawal', matched: false },
  ],
  accounts: [
    { id: 'A-1', code: '1000', name: 'Operating Checking', type: 'Bank', balance: 48280.10 },
    { id: 'A-2', code: '1010', name: 'Savings', type: 'Bank', balance: 25000 },
    { id: 'A-3', code: '1100', name: 'Accounts Receivable', type: 'Accounts Receivable', balance: 5137 },
    { id: 'A-4', code: '1200', name: 'Inventory – Chemicals', type: 'Other Current Asset', balance: 12400 },
    { id: 'A-5', code: '1500', name: 'Vehicles & Equipment', type: 'Fixed Asset', balance: 184000 },
    { id: 'A-6', code: '2000', name: 'Accounts Payable', type: 'Accounts Payable', balance: 2790 },
    { id: 'A-7', code: '2100', name: 'Business Card', type: 'Credit Card', balance: 319.99 },
    { id: 'A-8', code: '3000', name: 'Owner Equity', type: 'Equity', balance: 100000 },
    { id: 'A-9', code: '4000', name: 'Service Revenue', type: 'Income', balance: 84250 },
    { id: 'A-10', code: '5000', name: 'Chemicals & Supplies', type: 'Expense', balance: 18400 },
    { id: 'A-11', code: '5100', name: 'Fuel', type: 'Expense', balance: 6120 },
    { id: 'A-12', code: '5200', name: 'Payroll', type: 'Expense', balance: 32500 },
    { id: 'A-13', code: '5300', name: 'Insurance', type: 'Expense', balance: 4200 },
    { id: 'A-14', code: '5400', name: 'Office Supplies', type: 'Expense', balance: 1850 },
    { id: 'A-15', code: '5500', name: 'Equipment', type: 'Expense', balance: 3800 },
  ],
});

export const loadState = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      const s = seed();
      localStorage.setItem(KEY, JSON.stringify(s));
      return s;
    }
    return JSON.parse(raw);
  } catch {
    const s = seed();
    localStorage.setItem(KEY, JSON.stringify(s));
    return s;
  }
};

export const saveState = (s) => { localStorage.setItem(KEY, JSON.stringify(s)); };
export const resetState = () => { localStorage.removeItem(KEY); return loadState(); };

export const newId = uid;

export const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n || 0);

export const computeKPIs = (s) => {
  const invoices = s.invoices || [];
  const expensesArr = s.expenses || [];
  const billsArr = s.bills || [];
  const income = invoices.reduce((a, i) => a + invoicePaid(i), 0);
  const expenses = expensesArr.reduce((a, e) => a + (e.amount || 0), 0);
  const ar = invoices.filter(i => i.status !== 'Paid').reduce((a, i) => a + invoiceOutstanding(i), 0);
  const ap = billsArr.filter(b => b.status !== 'Paid').reduce((a, b) => a + (b.amount || 0), 0);
  const overdue = invoices.filter(i => i.status === 'Overdue').reduce((a, i) => a + invoiceOutstanding(i), 0);
  const profit = income - expenses;
  return { income, expenses, ar, ap, overdue, profit };
};
